import Auth from "../pages/auth";
import React, { useState } from "react";
import { Outlet, Route, Routes, Navigate } from "react-router-dom";
import SideMenu from "components/sideMenu/SideMenu";
import DashboardHeader from "components/dashboardHeader/DashboardHeader";
import ResetPassword from "pages/auth/resetPassword/ResetPassword";
import ChangePassword from "pages/changePassword/ChangePassword";
import { routes } from "./routes";
import { getToken } from "config/axiosInstance";

const Routing = () => {
  const DashboardRoutes = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    return (
      <>
        <section className={`dashboard_section ${sidebarOpen ? "sidebar_open" : ""}`}>
          <div className="sidebar_section">
            <SideMenu toggleSidebar={() => setSidebarOpen(false)} />
          </div>
          <div className="main_content">
            <DashboardHeader toggleSidebar={() => setSidebarOpen(!sidebarOpen)} />
            <div className="dashboard_content">
              <Outlet />
            </div>
          </div>
          {sidebarOpen && (
            <div className="sidebar_overlay" onClick={() => setSidebarOpen(false)} />
          )}
        </section>
      </>
    );
  };

  const ProtectedRoute = ({ children }) => {
    if (!getToken()) {
      return (
        <>
          <Navigate to="/" replace />
          {/* {toastMessage("session Expire Login again", "error", "tokenMissing")} */}
        </>
      );
    } else {
      return children;
    }
  };

  return (
    <>
      <Routes>
        <Route key={201} path="/" element={<Auth />} />
        <Route
          key={301}
          path="/reset-password/:token"
          element={<ResetPassword />}
        />
        <Route key={401} path="" element={<DashboardRoutes />}>
          {routes() && routes().length > 0
            ? routes().map((data, index) => (
                <Route
                  key={index}
                  path={data?.path}
                  element={<ProtectedRoute>{data?.element}</ProtectedRoute>}
                />
              ))
            : null}
          <Route
            key={501}
            path="/change-password"
            element={
              <ProtectedRoute>
                <ChangePassword />
              </ProtectedRoute>
            }
          />
        </Route>
      </Routes>
    </>
  );
};
export default Routing;
